import React, {useEffect, useState} from 'react';
import Rewards from '../../../common/customer.loyalty/spoonity-loyalty/rewards';
import BalancesView from '@/common/customer-balances/BalancesView';
import SpoonityAccountVerification from "@/common/customer.loyalty/spoonity-loyalty/verification";
import BurnRules from "@/common/customer.loyalty/spoonity-loyalty/burn-rules";

const { Customer } = Mobi2Go;

const LoyaltyModal = ({ closeModal }) => {
    const [isSpoonityEnabled, setIsSpoonityEnabled] = useState(false);
    const [isCustomerOptedIn, setIsCustomerOptedIn] = useState(false);
    const [isAccountVerified, setIsAccountVerified] = useState(false);

    useEffect(() => {
        const updateState = () => {
            setIsSpoonityEnabled(Customer.getLoyalty('SpoonityLoyalty')?.program?.settings?.authentication_enabled);
            setIsCustomerOptedIn(Customer.getLoyaltyOptIn());
            setIsAccountVerified(Customer.getLoyalty('SpoonityLoyalty')?.state?.is_profile_verified);
        };
        Customer.bind({
            updateLoyalty: updateState,
        });
        updateState();
        return () => {
            Customer.unbind({
                updateLoyalty: updateState,
            });
        };
    }, []);

    return (
        <>
            {isSpoonityEnabled && !isAccountVerified && (
                    <SpoonityAccountVerification />
                )
            }

            {isSpoonityEnabled && isCustomerOptedIn && <BurnRules />}
            {Customer.isLoggedIn() && <BalancesView/>}
            <Rewards closeModal={closeModal} />
        </>
    );
};

export default LoyaltyModal;
